import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/short cake.png";
import BiscuitImg from "../../../assets/products/crispy bites/Short-Cake-Biscuits.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 27,
  },
];

export default function ShortcakeProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Shortcake Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Shortcake Biscuits — buttery, crisp, and delightfully rich. View pack sizes, carton details, and global specs."
        />
        <meta
          name="keywords"
          content="Crispy Shortcake Biscuit, BearBitz Shortcake Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/shortcake"
        />
        <meta
          property="og:title"
          content="Crispy Shortcake Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Buttery and crispy shortcake biscuits by BearBitz, crafted with premium quality for global markets."
        />
      </Helmet>

      <ProductTemplate
        productTitle="SHORT CAKE"
        productImage={BisImg}
        description="Pure Butter. Pure Bliss. Golden, melt-in-mouth cookies that add richness to every celebration. Ideal for festive gifting and premium export assortments."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#CA8000"
        sectionBgColor="#FEEFD0"
        productBgcolor="#FDD176"
        tableheadBgcolor="#CA8000"
        tableBgcolor="#FFF9ED"
        footerBgcolor="#CA8000"
      />
    </>
  );
}
